import Component from 'vue-class-component';
import { Mutation } from 'vuex-class';
import { Prop, Vue } from 'vue-property-decorator';
import MockData from '@/globals/mock';
import { UPDATE_EXTERNAL_INCOME } from '@/types/form.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { ExternalIncomeItem } from '@/views/dashboard/form101/steps/tax-details-step/external-income-table/models/external-income-item.model';
import { BaseSelectItemModel } from '@/models/form/base-select-item.model';


@Component({})

export default class ExternalIncomeItemComponent extends Vue {
  @Prop({ default: () => ({} as ExternalIncomeItem) })
  public externalIncomeItem!: ExternalIncomeItem;

  @Prop()
  public externalIndex!: number;
  
  @Mutation(UPDATE_EXTERNAL_INCOME, StoreNamespace.FORM) public updateExternalIncome;

  private externalIncomeTypes: BaseSelectItemModel[] = MockData.form101.taxDetails.externalIncomeTypes;

  private updateIncome(value: string | number, property: string, id: string): void {
    this.updateExternalIncome({value, property, id});
  }
}
